import classes from "./premiumPlanCards.module.css";
import cx from "classnames";
import { getFormattedPrice } from "../../utils/creditUtils";

const DiscountPriceTag = ({ isSaleLive = false, item, bgColor = null }) => {
  const { discountedCostPerJob, skuId, discountPercentage } = item;
  const centeredClass = "flex justify-center";
  if (isSaleLive) {
    return (
      <div className={cx(classes.salePriceCnt, centeredClass)}>
        <div
          className={cx(classes.oneJobPrice, classes.salePrice, centeredClass)}
          style={bgColor ? { background: bgColor } : undefined}
        >
          <b>₹{getFormattedPrice(discountedCostPerJob)}</b> per job
        </div>
      </div>
    );
  }
  return (
    <>
      <div className={cx(classes.oneJobPriceCnt, centeredClass)}>
        <div
          className={cx(
            classes.oneJobPrice,
            centeredClass,
            skuId == 3 ? classes.redCnt : null
          )}
        >
          <img
            src={skuId === 3 ? "/hire/red-stars.svg" : "/hire/yellow-star.svg"}
            alt="stars"
          />
          <b>₹{getFormattedPrice(discountedCostPerJob)}</b> per job
        </div>
      </div>
      <div
        className={cx(
          discountPercentage
            ? classes.flatDiscount
            : classes.flatDiscountZeroDiscount,
          centeredClass
        )}
      >
        {discountPercentage ? <>Flat {discountPercentage}% Off</> : null}
      </div>
    </>
  );
};
export default DiscountPriceTag;
